export class DialogModelSearchByInvoice {
    constructor(
      public invoiceNumber: any
    ) {}
  }
  